export enum ContractTypeEnum {
	EMPRESARIAL = 'EMPRESARIAL',
	INDIVIDUAL_FAMILIAR = 'INDIVIDUAL FAMILIAR',
}
